import { PluginListenerHandle } from "@capacitor/core";
import { Toast } from "@eventr/native/toast";
import { getCachedRoomType } from "./native-rocket-toast";

let handle: PluginListenerHandle | null = null;

/**
 * chatType is required despite being optional on openChat - an empty value misroutes
 * non-DM rooms as direct messages. Read from the cache populated in createRocketSnack.tsx.
 */
export function startNativeToastTapListener(openChat: (roomId?: string, chatType?: string) => Promise<void>) {
  if (handle) return;
  Toast.addListener("tapped", ({ id }) => {
    void openChat(id, getCachedRoomType(id));
  }).then((h) => {
    handle = h;
  });
}

export function stopNativeToastTapListener() {
  handle?.remove();
  handle = null;
}
